<template>
  <v-app id="app">
    <!--<v-dialog v-model="loader" persistent width="300">
            <v-card color="primary" dark class="global-loader">
                <v-card-text>
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>-->

    <div class="global-loader-cont" v-if="loader">
      <v-card color="primary" dark class="global-loader" id="global-loader">
        <v-card-text>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </div>

    <!-- APP UPDATE SNACKBAR -->
    <v-snackbar :timeout="-1" bottom right v-model="newversion_snackbar">
      {{ $t("global.new_version") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" class="darken-2" small v-bind="attrs" @click="refreshPage()">{{ $t("global.refresh") }}</v-btn>
      </template>
    </v-snackbar>

    <router-view v-if="show" />
  </v-app>
</template>

<script>
export default {
  name: "my-master",

  data() {
    return {
      dialog: true,
      show: false
    }
  },

  created: function () {
    ///////////////////////////////////////////////////////////
    // AXIOS
    ///////////////////////////////////////////////////////////

    this.$checkAppVersion()

    axios.interceptors.request.use(
      (config) => {
        if (this.$store.getters["master/axiosHideLoader"]) {
        } else {
          this.$store.dispatch("master/setLoader", true)
        }

        // Headers
        config.headers["X-Locale"] = this.$getSetting("locale")
        config.headers["Vue-Check-Version"] = this.$store.getters["master/versionCheck"]
        //config.headers["Vue-Tenant-App-Version"] = process.env.VUE_APP_VERSION

        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      (response) => {
        // Hide Loader
        this.$store.dispatch("master/setLoader", false)
        this.$store.dispatch("master/setAxiosHideLoader", false)

        // Hide Global Messages
        // this.$globalMessages("", "", false);
        return response
      },
      (error) => {
        // Version mismatch - Reload page
        /*if (419 === error.response.status) {
          window.location.reload(true)
        }*/

        // Form error messages
        if (422 === error.response.status || 410 === error.response.status) {
          let errors = this.$formatErrorMessages(error.response.data.errors)
          this.$globalMessages(errors, "error")
          window.scrollTo({ top: 0, behavior: "smooth" })
        }

        // Tenant Inactive
        if (450 == error.response.status) {
          this.$clearCookies()
          this.$store.dispatch("settings/reset", this)
          this.$store.dispatch("auth/logout", this)
          this.$awn.alert(this.$t("global.error_tenant_inactive"))
          window.scrollTo({ top: 0, behavior: "smooth" })
        }

        // Hide Loader
        this.$store.dispatch("master/setLoader", false)
        return Promise.reject(error)
      }
    )

    ///////////////////////////////////////////////////////////
    // ROUTES
    ///////////////////////////////////////////////////////////
    this.$router.beforeEach((to, from, next) => {
      // Hide Global Messages
      this.$globalMessages("", "", false)

      let module = to.meta.module
      let permissions = to.meta.permissions

      // Fetch notifications
      this.$store.dispatch("notification/syncNotifications")

      // increase route count
      this.$store.dispatch("master/increaseRouteCount")
      var routeCount = this.$store.getters["master/routeCount"]

      if (routeCount > 0) {
        this.$store.dispatch("master/setVersionCheck", true)
      }

      this.$setCurrentModule(module)

      if (this.user.id) {
        const hasPermission = this.routeCheck(permissions)

        if (hasPermission || module == "auth" || module == "errors") {
          this.$checkAppVersion()
          if (this.$routeExtraModule(module) == "inactive") {
            this.routeFailed()
          } else {
            next()
          }
        } else {
          this.$setCurrentModule(from.meta.module)
          this.routeFailed(false)
        }
      } else {
        this.$checkAppVersion()
        next()
      }
    })

    this.routeInit()

    ///////////////////////////////////////////////////////////
    // AUTH
    ///////////////////////////////////////////////////////////
    this.tenantCheck()
    this.check()

    ///////////////////////////////////////////////////////////
    // NOTIFICATION
    ///////////////////////////////////////////////////////////
    this.$store.dispatch("notification/syncNotifications")
    let vm = this
    setInterval(function () {
      let showNotificationBar = false
      let activeNotifications = []
      let notifications = vm.$store.getters["notification/newNotifications"]

      notifications.forEach((notif, index) => {
        let current_datetime = vm.moment().utc()
        let start_datetime = vm.moment.utc(notif.start_datetime_utc)
        let end_datetime = vm.moment.utc(notif.end_datetime_utc)

        let validStartDateTime = start_datetime.isBefore(current_datetime)
        let validEndDateTime = end_datetime.isAfter(current_datetime)

        if (validStartDateTime && validEndDateTime) {
          if (notif.type == "bar") {
            showNotificationBar = true
          }

          activeNotifications.push(notif)
        }
      })

      vm.$store.dispatch("notification/setActiveNotifications", activeNotifications)
      vm.$store.dispatch("notification/setShowNotificationBar", showNotificationBar)
    }, 3000)
  },

  computed: {
    loader: {
      get() {
        return this.$store.getters["master/loader"]
      },
      set(value) {
        this.$store.dispatch("master/setLoader", value)
      }
    },
    locale: {
      get() {
        let locale = this.$getSetting("locale")
        return locale ? locale : "en"
      },
      set(value) {
        if (value) {
          this.$updateSetting("locale", value)
          this.$i18n.locale = value
        }
      }
    },
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    newversion_snackbar: {
      get() {
        return this.$store.getters["master/newVersionSnackbar"]
      },
      set(value) {
        this.$store.dispatch("master/setNewVersionSnackbar", value)
      }
    }
  },

  watch: {
    locale: {
      handler: function (val, oldVal) {
        this.locale = val
      }
    }
  },

  methods: {
    refreshPage() {
      window.location.reload(true)
    },
    check() {
      let user = this.$store.getters["auth/localUser"]
      let vm = this

      if (this.$checkAllCookies() && user) {
        let tenant_token = this.$cookies.get(`${this.COOKIE_PREFIX}tenant_token`)
        let certreg_token = this.$cookies.get(`${this.COOKIE_PREFIX}certreg_token`)
        let tenant_id = this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`)

        vm.$setAuthorization(tenant_token)
        vm.$setCertRegAuthorization(certreg_token)
        vm.$setTenantInAxiosHeader(tenant_id)

        /* ORGANISATION */
        if (this.$cookies.get(`${this.COOKIE_PREFIX}organisation_id`)) {
          axios
            .get(this.API_URL + "organisation/my?resourcetype=basic")
            .then((res) => {
              let data = res.data.data
              this.$store.dispatch("organisations/setOrganisationId", data.id)
              this.$store.dispatch("organisations/setOrganisation", data)

              this.$cookies.set(`${this.COOKIE_PREFIX}tenant_id`, data.tenant_id)
              this.$cookies.set(`${this.COOKIE_PREFIX}organisation`, data)
              this.$cookies.set(`${this.COOKIE_PREFIX}organisation_id`, data.id)
            })
            .catch((err) => console.log(err))
        }

        axios({
          method: "get",
          url: this.API_URL + "auth/user"
        })
          .then((res) => {
            let status = res.data.data.status
            let forcechangepassword = res.data.data.force_change_password
            let force_logout = res.data.data.force_logout
            let path = vm.$router.currentRoute.path

            if (force_logout) {
              this.$clearCookies()
              this.$store.dispatch("settings/reset", this)
              this.$store.dispatch("auth/logout", this)
            } else {
              vm.$init(tenant_token, res.data.data)

              // Check if path ends with "forcechangepassword", this trick is applied if they refreshed the page while one the forcechangepassword screen and it will not do a multiple redirect to the forcechangepassword link
              if (forcechangepassword && status == 1 && !path.endsWith("/forcechangepassword")) {
                this.$store.dispatch("master/setRouteCount", -1)
                this.$router.push("/auth/" + this.locale + "/forcechangepassword").catch((err) => {})
              }

              if (
                vm.$router.currentRoute.path == "/" ||
                vm.$router.currentRoute.path == "/app" ||
                vm.$router.currentRoute.path == "/app/"
              ) {
                if (status == 1 && !forcechangepassword) {
                  this.$store.dispatch("master/setRouteCount", -1)
                  this.$router.push(this.BACKEND_URL + "/dashboard").catch((err) => {})
                }
              } else {
                vm.routeInit()
              }
            }
          })
          .catch((err) => {
            if (err.response.status == 401) {
              vm.$clearCookies()
              vm.$store.dispatch("settings/reset", vm)
              vm.$store.dispatch("auth/no/logout", vm)
            }
          })
      } else {
        this.$clearCookies()
        this.$store.dispatch("settings/reset", this)
        localStorage.removeItem("__crrntUser")

        let path = vm.$router.currentRoute.path
        let segments = ["/f/", "/auth/", "/embed/"]
        let allowed = false

        for (let segment of segments) {
          if (path.startsWith(segment)) {
            allowed = true
          }
        }

        if (!allowed) {
          vm.$store.dispatch("master/setRouteCount", -1)
          vm.$router.push("/auth/no/login").catch((err) => {})
        } else {
          vm.$router.push(path).catch((err) => {})
        }
      }
    },

    routeCheck(permissions) {
      let bool = false

      for (let i in permissions) {
        const permission = permissions[i]
        if (this.$can(permission) || permission == "all") {
          bool = true
        }
      }

      if (!bool && this.$hasRole("system-developer")) {
        bool = true
      }

      return bool
    },

    routeInit() {
      let module = this.$router.currentRoute.meta.module
      let permissions = this.$router.currentRoute.meta.permissions

      this.$setCurrentModule(module)

      if (this.user.id) {
        const hasPermission = this.routeCheck(permissions)

        if (!hasPermission) {
          this.routeFailed()
        }

        if (this.$routeExtraModule(module) == "inactive") {
          this.routeFailed()
        }
      }
    },

    routeFailed(redirect = true) {
      let vm = this

      vm.$swal({
        title: this.$t("global.no_permission_title"),
        text: this.$t("global.no_permission_text"),
        icon: "error"
      }).then(function () {
        if (redirect) {
          vm.$store.dispatch("master/setRouteCount", -1)
          vm.$router.push(vm.BACKEND_URL + "/dashboard").catch((err) => {})
        }
      })
    },

    tenantCheck() {
      let vm = this
      let subdomain = this.SUBDOMAIN

      axios({
        method: "post",
        url: this.ADMIN_API_URL + "auth/tenant/check",
        data: {
          subdomain: subdomain,
          type: 1 // 1 = Kursweb
        }
      })
        .then((res) => {
          this.show = true
          this.$store.dispatch("master/setTenant", res.data.tenant)
          this.$store.dispatch("master/setTenantOrganisation", res.data.tenant.organisation)
        })
        .catch((error) => {
          if (error.response) {
            // 499 - Tenant does not exist
            if (error.response.status == 499) {
              this.show = true
              localStorage.removeItem("__crrntUser")
              vm.$router.push("/error/tenant-not-exist").catch((err) => {})
            }
          }
        })
    }
  }
}
</script>
